export  class TicketConversationMessage {

    public name: string;
    public date: string;
    public text: string;
    public isManager: boolean;

    constructor(obj?: any) { 
        this.name       = obj && obj.name        || '';
        this.date       = obj && obj.date        || '';
        this.text       = obj && obj.text        || '';
        this.isManager  = obj && obj.isManager   || false;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ticket-conversation-message.model.ts